import React, { Component } from "react";
import { connect } from "react-redux";
import { getBonusMessageSummaryReport } from "../../../store/ducks/report/actions";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import BonusMessageSummaryReportListing from "./BonusMessageSummaryReportListing";
import BonusMessageSummaryDetails from "./BonusMessageSummaryDetails";
import Swal from "sweetalert2";
import Button from "../../../components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import axios from "../../../common/config/axios";
import * as moment from "moment";
import { withNamespaces } from "react-i18next";
import { filterErrorHandler } from "../../../hoc/Shared/utility";

const initialInputState =
{
    /* form input value */
    transaction_date: '',
    start_date: moment().subtract(6, 'days').format('YYYY/MM/DD')+" 12:00:00 AM",
    end_date: moment().format('yyyy/MM/DD')+" 11:59:59 PM",
};

initialInputState.transaction_date = initialInputState.start_date + " - " + initialInputState.end_date;

class BonusMessageSummaryReport extends Component {
    /* ======================== Component Lifecycle [START] ======================== */
    constructor(props) {
        super(props);
        this.state = {
            pageShow: "listing",
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalPages: 0,
            totalRecords: 0,
            data: [],
            popupLoading: false,
            // loading: false,
            loading: true,
            dataLoading: false,
            permission: [],
            detailsParam: {},
            filter: initialInputState,
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.getBonusMessageSummaryReport(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            let reportPermission = this.props.currentPermission.filter((item) => item.includes("report_deposit_day_"));
            this.setState({ permission: reportPermission });
        }

        if (nextProps.reportData !== this.props.reportData && nextProps.reportData !== undefined) {
            if (nextProps.reportData.data.responseCode === 200 && nextProps.reportData.data.msgType === "success") {
                this.setState({
                    data: nextProps.reportData.data.data.result.row,
                    totalRecords: nextProps.reportData.data.data.result.pagination.total_record,
                    totalPages: nextProps.reportData.data.data.result.pagination.total_page,
                    loading: false,
                });
                Swal.close();
            } else {
                this.setState({
                    loading: false,
                    totalPages: 0,
                    activePage: 1,
                    totalRecords: 0,
                    data: []
                }, () => 
                {
                    filterErrorHandler(nextProps.reportData.data.message);
                });
            }
        }

        return true;
    }
    /* ======================== Component Lifecycle [END] ======================== */

    onInputChange(event) {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;

        if(event.target.id==='transaction_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

        this.setState({
            filter: newFilter,
        });
    }

    refreshHandler = () => {
        this.setState(
            {
                loading: true,
                dataLoading: true,
                data: [],
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                order: null,
            },
            () => {
                if (this.state.dataLoading) {
                    const listingArr = this.getFilterArray();
                    this.props.getBonusMessageSummaryReport(listingArr);
                }
            }
        );
    };

    clearHandler = () => {
        let newFilter = initialInputState;
        this.setState(
            {
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                order: null,
                totalRecords: 0,
                loading: true,
                dataLoading: false,
                data: [],
                filter: newFilter
            },
            () => {
                // if (this.state.dataLoading) {
                    const listingArr = this.getFilterArray();
                    this.props.getBonusMessageSummaryReport(listingArr);
                // }
            }
        );
    };

    getFilterArray = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }

        listingArr.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.country_id = this.props.currentCountryId;
        Object.keys(this.state.filter).forEach((val) =>
        {
            listingArr[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });
        return listingArr;
    };

    changePageHandler = (page) => {
        // console.log(page);
        this.setState({
            pageShow: page,
            popupLoading: true,
        });
    };

    exportExcelHandler = () => {
        const data = {};
        data.number_of_days = this.state.filter.number_of_days;
        data.min_deposit = this.state.filter.min_deposit;
        data.filter_member_group = this.state.filter.filter_member_group;
        data.filter_deposit_status = this.state.filter.filter_deposit_status;
        data.filter_transaction_date = this.state.filter.filter_transaction_date;
        data.filter_register_date = this.state.filter.filter_register_date;
        data.order = JSON.stringify(this.state.order);
        data.username = this.state.filter.username;

        axios
            .get("get_day_deposit_report/export_excel", {
                params: data,
                responseType: "blob",
            })
            .then((res) => {
                const currentDate = new Date();
                const timestamp = moment(currentDate).format("YYMMDD HHmmss");
                let fileName = `${process.env.REACT_APP_MERCHANT_SLUG} Report - MemberDeposit ` + timestamp;
                const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
                const aElement = document.createElement("a");
                const href = window.URL.createObjectURL(blob);
                aElement.href = href;
                aElement.download = fileName;
                document.body.appendChild(aElement);
                aElement.click();
                document.body.removeChild(aElement);
                window.URL.revokeObjectURL(href);
            })
            .catch((err) => {
                console.log("Excel - MemberDeposit Error", err);
            });
    };

    emailHandler = (e, email) => {
        e.preventDefault();
        window.location.href = `mailto:${email}`;
    };

    phoneHandler = (e, contactNo) => {
        e.preventDefault();
        // window.location.href = `tel:${contactNo}`;
        window.location.href = `callto:${contactNo}`; // Default Skype
    };
    /* ======================== Function [END] ======================== */

    /* ======================== Datatables Function [START] ======================== */
    datatablesChangeHandler = (val, act) => {
        this.setState(
            {
                [act]: act === "searchValue" ? val.target.value : val,
                loading: true,
                data: [],
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.getBonusMessageSummaryReport(listingArr);
            }
        );
    };

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = order === "asc" ? true : false;

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState({ 
            order: orderArry,
            loading: true,
            dataLoading: true,
            data: [],
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.getBonusMessageSummaryReport(listingArr);
        });
    };

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
        return <span>{rowNumber}</span>;
    };

    actionFormatter = (cell, row) => {
        let emailButton, phoneButton, output;
        emailButton = (
            <Button
                typeButton="button"
                classValue="btn btn-sm btn-white mr-2"
                key={`email-${row.memberId}`}
                idValue={row.memberId === undefined ? 0 : row.memberId}
                clicked={(event) => this.emailHandler(event, row.email)}
                buttonName={<FontAwesomeIcon icon={faEnvelope} />}
            />
        );

        phoneButton = (
            <Button
                typeButton="button"
                classValue="btn btn-sm btn-white"
                key={`phone-${row.memberId}`}
                idValue={row.memberId === undefined ? 0 : row.memberId}
                clicked={(event) => this.phoneHandler(event, row.contactNo)}
                buttonName={<FontAwesomeIcon icon={faPhone} />}
            />
        );

        output = [emailButton, phoneButton];
        return output;
    };
    /* ============ Datatables Function [END] ============ */

    detailsHandler = (e, date, type, status) => {
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam : {
                date: moment(date).format("YYYY-MM-DD"),
                returnPage: 'listing',
                type: type,
                status: status
            }
        });
    }

    luckySpinFormatter = (cell, row) => {
        let read, unread, output;
        read = <span className="badge badge-primary">R: <a href="/#" onClick={(event) => this.detailsHandler(event, row.created_at, "Lucky Spin", 1)}>{row.luckySpinRead}</a></span>;
        unread = <span className="badge badge-primary">UR: <a href="/#" onClick={(event) => this.detailsHandler(event, row.created_at, "Lucky Spin", 0)}>{row.luckySpinNotRead}</a></span>;
        output = [read, unread];
        return output;
    };

    rescueBonusFormatter = (cell, row) => {
        let read, unread, output;
        read = <span className="badge badge-primary">R: <a href="/#" onClick={(event) => this.detailsHandler(event, row.created_at, "Rescue Bonus", 1)}>{row.rescueBonusRead}</a></span>;
        unread = <span className="badge badge-primary">UR: <a href="/#" onClick={(event) => this.detailsHandler(event, row.created_at, "Rescue Bonus", 0)}>{row.rescueBonusNotRead}</a></span>;
        output = [read, unread];
        return output;
    }

    dailyMissionCheckInFormatter = (cell, row) => {
        let read, unread, output;
        read = <span className="badge badge-primary">R: <a href="/#" onClick={(event) => this.detailsHandler(event, row.created_at, "Daily Mission Check In", 1)}>{row.dailyMissionCheckInRead}</a></span>;
        unread = <span className="badge badge-primary">UR: <a href="/#" onClick={(event) => this.detailsHandler(event, row.created_at, "Daily Mission Check In", 0)}>{row.dailyMissionCheckInNotRead}</a></span>;
        output = [read, unread];
        return output;
    }

    render() {
        const { t } = this.props;
        let ddMemberGroup = [];
        let dataListing = [];

        const columns = [
            // { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px" } },
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px" } },
            { text: t("report.date"), dataField: "created_at", sort: true, onSort: this.onSort },
            { text: t("report.lucky-spin"), dataField: "#", formatter: this.luckySpinFormatter, sort: false, onSort: this.onSort },
            { text: t("report.rescue-bonus"), dataField: "#", formatter: this.rescueBonusFormatter, sort: false, onSort: this.onSort },
            { text: t("report.daily-mission-check-in"), dataField: "#", formatter: this.dailyMissionCheckInFormatter, sort: false, onSort: this.onSort },
        ];

        if (this.state.pageShow === "listing") {
            if (this.state.data.length > 0) {
                dataListing = this.state.data.map((val, idx) => {
                    return {
                        created_at: val.created_at,
                        luckySpinRead: val.luckySpinRead,
                        luckySpinNotRead: val.luckySpinNotRead,
                        rescueBonusRead: val.rescueBonusRead,
                        rescueBonusNotRead: val.rescueBonusNotRead,
                        dailyMissionCheckInRead: val.dailyMissionCheckInRead,
                        dailyMissionCheckInNotRead: val.dailyMissionCheckInNotRead
                    };
                });
            }
        }

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <BonusMessageSummaryReportListing
                        filter={this.state.filter}
                        refreshHandler={() => this.refreshHandler()}
                        clearHandler={() => this.clearHandler()}
                        exportExcelHandler={() => this.exportExcelHandler()}
                        onInputChange={(event) => this.onInputChange(event)}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        columns={columns}
                        dataListing={dataListing}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        postSearchHandler={this.postSearchHandler}
                        searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                        loading={this.state.loading}
                        permission={this.state.permission}
                        ddMemberGroup={ddMemberGroup}
                    />
                )}

                {this.state.pageShow === "details" &&
                    <BonusMessageSummaryDetails 
                        detailsParam={this.state.detailsParam}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                }
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        reportData: state.report.get_bonus_message_summary_report_data,
        currentCountryId: state.currentUser.data.country_id,
        currentPermission: state.currentUser.data.permission
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBonusMessageSummaryReport: (filter) => dispatch(getBonusMessageSummaryReport(filter))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(BonusMessageSummaryReport));
